// src/components/DonutChart/DonutChart.js
import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

// Register the elements
Chart.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ good, ok, bad, isPlaceholder }) => {
  // If it's a placeholder, display greyed-out donut
  if (isPlaceholder) {
    const placeholderData = {
      datasets: [
        {
          data: [1, 1, 1], // Dummy data for the three sections
          backgroundColor: ['#cccccc', '#cccccc', '#cccccc'], // Greyed out
          hoverBackgroundColor: ['#b3b3b3', '#b3b3b3', '#b3b3b3'],
          cutout: '40%',
        }
      ],
      labels: ['Good', 'Ok', 'Bad']
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'right' // Set legend position to right
        }
      }
    };

    return (
      <div style={{ position: 'relative', width: '100%', height: '150px' }}>
        <Pie data={placeholderData} options={options} />
      </div>
    );
  }

  // Normal data case
  const data = {
    datasets: [
      {
        data: [good, ok, bad],
        backgroundColor: ['#00ff00', '#ffff00', '#ff0000'], // Good, Ok, Bad
        hoverBackgroundColor: ['#66ff66', '#ffff66', '#ff6666'],
        // Set the cutout percentage to create a donut chart
        // Set a suitable cutout percentage based on your preference
        cutout: '40%', // Donut size (80% of radius is hollow)
      }
    ],
    labels: ['Good', 'Ok', 'Bad']
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right' // Set legend position to right
      }
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '150px' }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default DonutChart;